import moment from 'moment';

import { PRODUCT_CODES, PARTNERS, DATE_FORMAT } from 'config/app-config';
import { usePartner } from 'components/app/routes/usePartner';
import { useJourneyData } from 'hooks/useJourneyData';
import { usePaymentMethod } from 'hooks/usePaymentMethod';
import { useElecMultirate } from 'hooks/useElecMultirate';
import { useHasSmartMeter } from 'components/direct-sales/quote/hooks/useHasSmartMeter';

export const useQuotePayload = () => {
  const { partnerName, activePartner } = usePartner();
  const {
    consumption,
    fuelType: { gas, electric },
    postcode,
    preferredStartDate: defaultPreferredStartDate
  } = useJourneyData();
  const { hasElectricitySmartMeter, hasGasSmartMeter } = useHasSmartMeter();
  const { paymentMethodNEP } = usePaymentMethod();
  const { showTOUTariffs, showE7Tariffs } = useElecMultirate();
  const productCode = PRODUCT_CODES[partnerName] || PRODUCT_CODES.DIRECT_SALES;
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];
  const today = moment().format(DATE_FORMAT);
  const defaultElecConsumption = consumption.electric;

  return (
    {
      isEconomy7 = showE7Tariffs,
      preferredStartDate = defaultPreferredStartDate,
      electricityConsumption = defaultElecConsumption
    } = {
      isEconomy7: showE7Tariffs,
      preferredStartDate: defaultPreferredStartDate,
      electricityConsumption: defaultElecConsumption
    }
  ) => {
    const electricityMeterPoints = [
      {
        postcode,
        consumptionStandard: electricityConsumption,
        hasSmartMeter: hasElectricitySmartMeter,
        isTOU: showTOUTariffs,
        isEconomy7
      }
    ];

    const gasMeterPoints = [
      {
        postcode,
        consumptionStandard: consumption.gas,
        hasSmartMeter: hasGasSmartMeter
      }
    ];

    return {
      ...(electric && { electricityMeterPoints }),
      ...(gas && { gasMeterPoints }),
      paymentMethod: paymentMethodNEP,
      productCodes: [productCode],
      preferredStartDate: isMoveInJourney ? today : preferredStartDate
    };
  };
};
